import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useFormGuardContext } from './FormGuardProvider';

/**
 * This hook is used to bind the form state to the form guard store.
 * It will propagate the form state to the form guard store.
 */
export const FormGuardBinder = () => {
  const store = useFormGuardContext();
  const setIsFormDirty = store?.((s) => s.setIsFormDirty);

  const { formState } = useFormContext();
  const isDirty = formState.isDirty;

  useEffect(() => {
    setIsFormDirty?.(isDirty);
  }, [isDirty, setIsFormDirty]);

  return null;
};
